module.exports = __webpack_public_path__ + "static/hcm-slider5-2f35930d4e97f28f67f3d00d74855c18.jpeg";